export default __webpack_public_path__ + "static/media/undraw_portfolio-feedback_4iok.90552b54.svg";